<template>
    <div class="app-container">
        <div v-if="isMobile">
            <MobileHeaderBack></MobileHeaderBack>
        </div>
        <!-- setting list -->
        <div class="list-container">
            <div class="list-title">
                {{ $t('ACCOUNT') }}
            </div>
    
            <div class="list">
                <template v-for="(item,index) in settingList">
                    <div class="list-item" 
                        @click="handleListItem(item)"
                        v-if="item.isLogin === undefined || 
                            item.isLogin === true && isLogin ">
                        <div>
                            {{ $t(item.name) }}
                            <!-- language display -->
                            <div v-if="item.name === 'COUNTRY_AND_LANGUAGE'"
                                class="language-text">
                                <div class="country-icon-box">
                                    <img :src="require(`../../../static/images/flags/${myCountryIcon}.png`)" 
                                        class="country-icon">
                                </div>
                                {{ currentCountryObj.country }} - {{ currentLanguageObj.displayName }}
                            </div>
                        </div>
                        <!-- theme switch -->
                        <div v-if="item.name === 'THEME'">
                            <label class="switch"
                                :class="isLight ? 'is-light' : 'is-dark'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" 
                                    class="switch-sun" 
                                    v-if="isLight">
                                    <path d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z" fill="#E6C200"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V3C12.75 3.41421 12.4142 3.75 12 3.75C11.5858 3.75 11.25 3.41421 11.25 3V2C11.25 1.58579 11.5858 1.25 12 1.25ZM4.39861 4.39861C4.6915 4.10572 5.16638 4.10572 5.45927 4.39861L5.85211 4.79145C6.145 5.08434 6.145 5.55921 5.85211 5.85211C5.55921 6.145 5.08434 6.145 4.79145 5.85211L4.39861 5.45927C4.10572 5.16638 4.10572 4.6915 4.39861 4.39861ZM19.6011 4.39887C19.894 4.69176 19.894 5.16664 19.6011 5.45953L19.2083 5.85237C18.9154 6.14526 18.4405 6.14526 18.1476 5.85237C17.8547 5.55947 17.8547 5.0846 18.1476 4.79171L18.5405 4.39887C18.8334 4.10598 19.3082 4.10598 19.6011 4.39887ZM1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H3C3.41421 11.25 3.75 11.5858 3.75 12C3.75 12.4142 3.41421 12.75 3 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12ZM20.25 12C20.25 11.5858 20.5858 11.25 21 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H21C20.5858 12.75 20.25 12.4142 20.25 12ZM18.1476 18.1476C18.4405 17.8547 18.9154 17.8547 19.2083 18.1476L19.6011 18.5405C19.894 18.8334 19.894 19.3082 19.6011 19.6011C19.3082 19.894 18.8334 19.894 18.5405 19.6011L18.1476 19.2083C17.8547 18.9154 17.8547 18.4405 18.1476 18.1476ZM5.85211 18.1479C6.145 18.4408 6.145 18.9157 5.85211 19.2086L5.45927 19.6014C5.16638 19.8943 4.6915 19.8943 4.39861 19.6014C4.10572 19.3085 4.10572 18.8336 4.39861 18.5407L4.79145 18.1479C5.08434 17.855 5.55921 17.855 5.85211 18.1479ZM12 20.25C12.4142 20.25 12.75 20.5858 12.75 21V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V21C11.25 20.5858 11.5858 20.25 12 20.25Z" fill="#E6C200"/>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    class="switch-moon" 
                                    v-else>
                                    <path d="M19.8999 2.30719C19.739 1.8976 19.1614 1.8976 19.0005 2.30719L18.5701 3.40247C18.521 3.52752 18.4224 3.62651 18.2978 3.67583L17.2065 4.1078C16.7984 4.26934 16.7984 4.849 17.2065 5.01054L18.2978 5.44252C18.4224 5.49184 18.521 5.59082 18.5701 5.71587L19.0005 6.81115C19.1614 7.22074 19.739 7.22074 19.8999 6.81116L20.3303 5.71587C20.3794 5.59082 20.478 5.49184 20.6026 5.44252L21.6939 5.01054C22.102 4.849 22.102 4.26934 21.6939 4.1078L20.6026 3.67583C20.478 3.62651 20.3794 3.52752 20.3303 3.40247L19.8999 2.30719Z" fill="#E6C200"/>
                                    <path d="M16.0327 8.12966C15.8717 7.72008 15.2942 7.72008 15.1332 8.12966L14.9763 8.52901C14.9272 8.65406 14.8286 8.75304 14.704 8.80236L14.3061 8.95986C13.898 9.1214 13.898 9.70106 14.3061 9.8626L14.704 10.0201C14.8286 10.0694 14.9272 10.1684 14.9763 10.2935L15.1332 10.6928C15.2942 11.1024 15.8717 11.1024 16.0327 10.6928L16.1896 10.2935C16.2387 10.1684 16.3373 10.0694 16.4619 10.0201L16.8598 9.8626C17.2679 9.70106 17.2679 9.1214 16.8598 8.95986L16.4619 8.80236C16.3373 8.75304 16.2387 8.65406 16.1896 8.52901L16.0327 8.12966Z" fill="#E6C200"/>
                                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 11.5373 21.3065 11.4608 21.0672 11.8568C19.9289 13.7406 17.8615 15 15.5 15C11.9101 15 9 12.0899 9 8.5C9 6.13845 10.2594 4.07105 12.1432 2.93276C12.5392 2.69347 12.4627 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#26B3FF"/>
                                </svg>
                                <input type="checkbox" v-model="isLight">
                                <span class="slider round"></span>
                            </label>
                        </div>
        
                        <SvgIcon icon="more.arrow.right" v-if="item.arrow"></SvgIcon>
                        
                    </div>
                </template>
            </div>
        </div>
    </div>
    
</template>

<script>
    import MobileHeaderBack from '@/components/mobile/HeaderBack.vue'
    import {mapGetters,mapActions} from 'vuex'

    export default {
        data() {
            return {
                settingList: [
                    {
                        name: 'PASSWORD',
                        arrow: true,
                        pathName: 'changePassword'
                    },
                    {
                        name: 'DELETE_ACCOUNT',
                        arrow: true,
                        pathName: 'deleteAccount'
                    },
                ],
            }
        },
        components: {
            MobileHeaderBack
        },
        computed: {
            ...mapGetters([
                'isMobile',
                'currentLocale',
                'isLogin',
                "userInfo",
                "currentLanguageObj"
            ]),
        },
        created() {
            if(!this.isMobile) {
                setTimeout(() => {
                    this.$router.push({
                        name: 'Home'
                    })
                }, 100)
            }
        },
        methods: {
            handleListItem(item) {
                if(item.pathName) {
                    this.$router.push({
                        name: item.pathName
                    })
                }
            }
        }
    }
</script>

<style scoped>

.list-title {
    color: var(--color-text-default-default);
    font-size: 20px;
    font-family: var(--weight-700);
    margin: 16px 0;
    padding: 0 24px;
    margin-top: 28px;
}
.list {
    padding: 0 8px;
}
.list-item {
    background-color: var(--color-background-default-secondary);
    border-radius: 16px;
    margin-bottom: 8px;
    font-size: 16px;
    font-family: var(--weight-700);
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    color: var(--color-text-default-default);
	letter-spacing: 0.64px;
    
}
.app-container {
    background-color: var(--color-background-default-default);
}
</style>